import { CloudOffIcon, RefreshCwIcon } from "lucide-react";
import StatusScreen from "../StatusScreen";
import S from "./styles.module.scss";

interface ConnectionErrorScreenProps {
  description: string;
  onRetry: () => void;
  fullscreen?: boolean;
}

const ConnectionErrorScreen = ({
  description,
  onRetry,
  fullscreen,
}: ConnectionErrorScreenProps) => (
  <StatusScreen
    fullscreen={fullscreen}
    visual={
      <span className={S.badge}>
        <CloudOffIcon size={36} strokeWidth={1.75} />
      </span>
    }
    title="Sem conexão com o servidor"
    description={description}
    actions={[
      { label: "Tentar novamente", icon: RefreshCwIcon, onClick: onRetry },
    ]}
  />
);

export default ConnectionErrorScreen;

